// Page à propos
function About() {
    return (
        <section className="max-w-3xl mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">About Me</h1>
            <div className="text-gray-300 leading-relaxed space-y-6">
                <p>Hi, I'm Guillaume Riou. I'm a software developer currently studying fullstack development at Metana Bootcamp.</p>
                <p>I'm passionate about building clean, efficient web applications and exploring modern technologies. My current stack includes React, Node.js, Express, and PostgreSQL.</p>
                <p>When I'm not coding, I enjoy learning about new technologies and working on personal projects that challenge me to grow as a developer.</p>
            </div>
        </section>
    );
}

export default About;